/**
 * 【配置工具模板专用】
 * 增删改页面通用mixin
 * 具体使用请参考官方文档：https://cn.vuejs.org/v2/guide/mixins.html
 */

// 混入commonListMixin
import commonListMixin from '@/pages/mixin/mixin-common-list'
// 导入配置信息
import setting from '@/setting.js'

export default {
    mixins: [
        commonListMixin
    ],
    data() {
        return {
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total:0
            },
            pageSizeList: [10, 20, 50, 100],
            // 自动加载表格开关
            autoLoadTableData: false,
            // 查询条件
            searchForm: {
                condition: '' //通用查询条件
            },
            editDialog: {
                width: '1100px',
                formLabelWidth: '180px',
                // 预留配置：指定修改接口需要提交的字段（id字段无需列出）
                apiUpdateFields: [
                    //'title','fileName','links','isActivation','indexes'
                ]
            },
            addDialog: {
                width: '900px',
            }
        }
    },
    mounted(){
        this.$nextTick(function () {
            // Code that will run only after the entire view has been rendered

            // 初始化工具模板数据
            this.initKitInfo()
        })
    },
    methods: {
        /**
         * 初始化工具模板数据
         */
        initKitInfo(){
            if(this.componentListCfg){
                // 接收组件参数（提示：对象为引用传递！）
                this.apiCfg = this.componentListCfg.apiCfg
                this.listCfg = this.componentListCfg.listCfg
                this.listNewCfg = this.componentListCfg.listNewCfg
                this.formRules = this.componentListCfg.formRules
            }

            // 初始化新配置（配置转换函数，listCfg为空时跳过本函数）
            this.initListNewCfg()
            // 初始化API地址信息
            this.initApiInfo()
            // 加载表数据（为防止重复请求，请确保autoLoadTableData值为false）
            this.getTableData()
            // 初始化高级查询的表单部分（防止重置表单，下拉框等控件失效问题）
            this.initQueryFormData()
        },
        /**
         * 初始化新配置（配置转换函数）
         * listCfg为空时跳过本函数
         */
        initListNewCfg() {
            // listCfg存在时，转换为新配置（覆盖原有listNewCfg）
            if(!!this.listCfg){
                console.log('开始转换listCfg配置格式...')
                let fieldLabel = this.listCfg.field_label
                let field = this.listCfg.field
                let fieldInfoArray = []
                for(let i in field){
                    let fieldObj = {}
                    if(field[i].indexOf('||')!=-1){
                        fieldObj.name = field[i].split('||')[0]
                        fieldObj.inType = 'SELECT_EXT'
                        fieldObj.inExt = field[i].split('||')[1]
                    }else if(field[i].indexOf('|')!=-1){
                        fieldObj.name = field[i].split('|')[0]
                        fieldObj.inType = 'SELECT_EXT'
                        fieldObj.inExt = field[i].split('|')[1]
                    }else if(field[i].indexOf('=')!=-1){
                        fieldObj.name = field[i].split('=')[0]
                        if(field[i].split('=')[1] == 'dt'){
                            fieldObj.inType = 'INPUT_DT'
                        }
                    }else{
                        fieldObj.name = field[i]
                    }
                    fieldObj.label = fieldLabel[i]
                    fieldObj.detail = field[i]

                    fieldInfoArray.push(fieldObj)
                }
                this.listNewCfg = {}
                this.listNewCfg.fieldInfo = fieldInfoArray
                this.listNewCfg.filters = fieldInfoArray
                this.listNewCfg.editInfo = fieldInfoArray
                this.listNewCfg.conditionLabel = this.listCfg.conditionLabel
                this.listNewCfg.url = this.listCfg.url
            }else if(!!this.apiCfg){
                console.log('开始转换apiCfg配置格式...')
                // 接口API存在时，转换为标准格式配置
                let fieldInfo = []
                let filters = []
                let editInfo = []
                let details = []
                /*{
                    "name": "infoType2",
                    "inType": "SELECT_EXT",
                    "inExt": "typeTwoApp",
                    "label": "信息二级分类",
                    "detail": "infoType2|typeTwoApp"
                },*/
                for(let i in this.apiCfg.shows){
                    let itemInfo = this.apiCfg.items[this.apiCfg.shows[i].col]
                    if(!!itemInfo){
                        fieldInfo.push({
                            name: this.apiCfg.shows[i].col,
                            inType: itemInfo.inType,
                            inExt: itemInfo.inExt,
                            label: itemInfo.label,
                            detail: itemInfo.expr
                        })
                    }
                }
                for(let i in this.apiCfg.filters){
                    let itemInfo = this.apiCfg.items[this.apiCfg.filters[i].name]
                    if(!!itemInfo){
                        filters.push({
                            name: this.apiCfg.filters[i].name,
                            inType: itemInfo.inType,
                            inExt: itemInfo.inExt,
                            label: this.apiCfg.filters[i].label,
                            detail: itemInfo.expr
                        })
                    }
                }
                for(let i in this.apiCfg.edits){
                    let itemInfo = this.apiCfg.items[this.apiCfg.edits[i].col]
                    if(!!itemInfo){
                        editInfo.push({
                            name: this.apiCfg.edits[i].col,
                            inType: itemInfo.inType,
                            inExt: itemInfo.inExt,
                            label: itemInfo.label,
                            detail: itemInfo.expr
                        })
                    }
                }
                for(let i in this.apiCfg.details){
                    let itemInfo = this.apiCfg.items[this.apiCfg.details[i].col]
                    if(!!itemInfo){
                        details.push({
                            name: this.apiCfg.details[i].col,
                            inType: itemInfo.inType,
                            inExt: itemInfo.inExt,
                            label: itemInfo.label,
                            detail: itemInfo.expr
                        })
                    }
                }
                this.listNewCfg = {}
                this.listNewCfg.fieldInfo = fieldInfo
                this.listNewCfg.filters = filters
                this.listNewCfg.editInfo = editInfo
                this.listNewCfg.details = details
                this.listNewCfg.conditionLabel = (this.apiCfg.conditionLabel?this.apiCfg.conditionLabel:'请输入通用查询条件')
                this.listNewCfg.url = this.apiCfg.url
            }
        },
        /**
         * 初始化高级查询的表单部分（防止重置表单，下拉框等控件失效问题）
         */
        initQueryFormData(){
            let filters = this.listNewCfg.filters
            let formObj = {}
            for(let i in filters){
                formObj[filters[i].name] = null
            }
            this.queryDialog.form = formObj
        },
        /**
         * 初始化API地址信息
         */
        initApiInfo(){
            let basePath = '/service/' + setting.systemInfo.key
            this.tableDataApi = basePath + this.listNewCfg.url
            this.deleteDataApi = basePath + this.listNewCfg.url
            this.editDialog.updateDataApi = basePath + this.listNewCfg.url
            this.addDialog.addDataApi = basePath + this.listNewCfg.url

        },
        /**
         * 字典数据解析通用函数
         */
        dealField(row, column, cellValue, index){
            let fieldInfo = this.listNewCfg.fieldInfo.filter(item => item.name === column.property)
            let detail = ''
            if(fieldInfo.length > 0){
                detail = fieldInfo[0].detail
            }
            // 字典转换-多个
            if(detail.indexOf("||") > 0){
                // 字典码
                let dic_type =  detail.split("||")[1]
                // 值数组
                let cellValueArray = (cellValue+'').split(',')
                if(this.dictInfo[dic_type]){
                    let descArray = this.dictInfo[dic_type].filter(item => cellValueArray.indexOf(item.key)!=-1 )
                    let result = [];
                    for(let i in descArray){
                        result.push(descArray[i].value)
                    }
                    return result.join(',')
                }
            }else if(detail.indexOf("|") > 0){
                // 字典转换-单个
                let dic_type =  detail.split("|")[1]
                if(this.dictInfo[dic_type]){
                    /*
                    {
                      "attribute":[
                          {"key":"1","value":"黑名单"},
                          {"key":"2","value":"灰名单"},
                          {"key":"3","value":"白名单"}
                      ]
                    }
                    */
                    let descArray = this.dictInfo[dic_type].filter(item => item.key == cellValue)
                    let result = [];
                    for(let i in descArray){
                        result.push(descArray[i].value)
                    }
                    return result.join(',')
                }
            }else if(detail.indexOf("=") > 0){
                // 自定义函数（目前支持：dt）
                let fun =  detail.split("=")[1]
                if(fun === 'dt'){
                    return this.formatterTimestamp(row, column, cellValue, index)
                }
            }
            return cellValue
        },
        /**
         * 【配置工具模板专用】
         * 修改数据提交
         * @param formName 可选参数，传入表单ref名称时，会进行规则校验
         * @param requestMethod 可选参数，默认值为this.editDialog.requestMethod，优先级高于提交函数updateTableData的requestMethod参数
         */
        updateTableDataForCfgTool(formName,requestMethod){
            if(this.$refs[formName]){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.updateTableDataAjaxForCfgTool(requestMethod)
                    }
                })
            }else{
                this.updateTableDataAjaxForCfgTool(requestMethod)
            }
        },
        /**
         * 【配置工具模板专用】
         * 确认并调用修改数据接口
         */
        updateTableDataAjaxForCfgTool(requestMethod){
            let requestData = {}
            //指定修改字段时，只拼接指定字段
            /*if(this.editDialog.apiUpdateFields){
                let apiUpdateFields = this.editDialog.apiUpdateFields
                for(let i in apiUpdateFields){
                    requestData[apiUpdateFields[i]] = this.editDialog.form[apiUpdateFields[i]]
                }
            }else{
                requestData = this.editDialog.form
            }*/
            requestData = this.editDialog.form
            if(this.editDialog.isEdit){
                requestData = {...{id: this.editDialog.editId},...requestData}
            }
            this.$axios({
                method: requestMethod?requestMethod:this.editDialog.requestMethod,
                url: this.editDialog.isEdit ? this.editDialog.updateDataApi : this.addDialog.addDataApi,
                data: requestData,
                //params:requestData
                headers: {
                    'Content-Type': 'application/json'
                },
                transformRequest: [function(data) {
                    return JSON.stringify(data)
                }]
            }).then(res => {
                if(res.code == 200){
                    /*this.$alert(res.message, '成功提示',{
                        callback: action => {
                            this.editDialog.dialogFormVisible = false
                            this.getTableData()
                        }
                    })*/
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.editDialog.dialogFormVisible = false
                    this.getTableData()
                }else{
                    this.$alert(res.message, '失败提示')
                }
            }).catch(function (error) {
                console.log(error)
            }).then(() => {
                this.loading = false
            });
        }
    },
    computed: {

    }
}
